import React, { use } from 'react';
import { useTranslation } from 'react-i18next';
import BroadcastOnPersonalOutlinedIcon from '@mui/icons-material/BroadcastOnPersonalOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import ResidentSettingsProviderContext from 'features/residents/resident-settings/providers/contexts/resident-settings-provider-context';
import DetailsDevices from './components/details-devices/details-devices';
import styles from './devices-accordion.module.scss';

const DevicesAccordion = (): React.JSX.Element => {
  const { t } = useTranslation('residentsSettings');
  const {
    detailEditState: { isDevicesAccordionExpanded, setIsDevicesAccordionExpanded },
  } = use(ResidentSettingsProviderContext);

  return (
    <Accordion expanded={isDevicesAccordionExpanded} disableGutters>
      <AccordionSummary
        sx={{ padding: 0, margin: '12px 0 0 0', '.MuiAccordionSummary-content': { margin: '0' } }}
        expandIcon={<ExpandMoreIcon onClick={() => setIsDevicesAccordionExpanded(!isDevicesAccordionExpanded)} />}
        aria-label="Expand"
        aria-controls="additional-actions1-content"
      >
        <Grid
          className={styles.accordionSummaryContent}
          onClick={() => setIsDevicesAccordionExpanded(!isDevicesAccordionExpanded)}
          onKeyDown={(e) => e.key === 'Enter' && setIsDevicesAccordionExpanded(!isDevicesAccordionExpanded)}
        >
          <BroadcastOnPersonalOutlinedIcon onClick={() => setIsDevicesAccordionExpanded(!isDevicesAccordionExpanded)} />
          <Typography variant="h5">{t('details.devicesDividerText')}</Typography>
        </Grid>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: '0 0 8px 0', margin: 0 }}>
        <DetailsDevices />
      </AccordionDetails>
    </Accordion>
  );
};

export default DevicesAccordion;
